import type { FC } from 'react';

import { cn } from './cn.js';

/** Полоска-заглушка на время загрузки. */
export const Skeleton: FC<{ className?: string }> = ({ className }) => (
  <span
    aria-hidden
    className={cn('block h-4 animate-pulse rounded bg-ink-150', className)}
  />
);
